import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchExperienceTripsDtl } from "../services/ExperienceTripsDtl";
import { API_BASE } from "../api/apiConfig";

const ExperienceDtlcount = () => {
  const { id } = useParams();
  const [ExperienceTripsDtldata, setExperienceTripsDtldata] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBanner = async () => {
      const res = await fetchExperienceTripsDtl(decodeURIComponent(id));

      if (res?.data) {
         setExperienceTripsDtldata(res.data[0]);
      }
      setLoading(false);
    };

    loadBanner();
  }, [id]);

  if (loading) return <p className="text-center py-10">Loading...</p>;
  if (!ExperienceTripsDtldata) return <p className="text-center py-10">No Data found</p>;

  return (
     
     <div className="hidden md:block py-4 md:py-6 border-b border-slate-100">
        <div className="flex flex-wrap items-center justify-between gap-3 md:gap-4">
          <div className="flex items-center gap-4 md:gap-6">
            <div>
              <p className="text-xs md:text-sm text-slate-500">Group Size</p>
              <p className="font-semibold text-slate-900 text-sm md:text-base">
                {ExperienceTripsDtldata.travelers}
              </p>
            </div>
            {/*<div>
              <p className="text-xs md:text-sm text-slate-500">Difficulty</p>
              <p className="font-semibold text-slate-900 text-sm md:text-base">
                Moderate to Challenging
              </p>
            </div>*/}
            <div className="hidden sm:block">
              <p className="text-xs md:text-sm text-slate-500">Spots Left</p>
              <p className="font-semibold text-primary text-sm md:text-base">
                {ExperienceTripsDtldata.spots} spots
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2 md:gap-3">
            <span className="text-slate-400 line-through text-sm md:text-lg">
              ₹{ExperienceTripsDtldata.difficulties}
            </span>
            <span className="text-lg sm:text-xl md:text-3xl font-bold text-slate-900">
              ₹{ExperienceTripsDtldata.charges}
            </span>
            <span className="text-slate-500 text-xs md:text-base">
              / person
            </span>
          </div>
        </div>
      </div>

 
  );
};

export default ExperienceDtlcount;
